interface Props {
  className?: string;
}

export const CardLoading = ({ className }: Props) => {
  return (
    <>
      <article
        className={`flex flex-col w-full max-w-2xs  h-full ${className} cursor-pointer`}>
        <div className='bg-green-default h-full animate-pulse'></div>
        <header className='pt-4 mt-auto h-10 flex flex-col '>
          <span className='h-12 bg-black w-3/4 animate-pulse mb-2'></span>
        </header>

        <section className='flex flex-row flex-wrap  border-gray-300  justify-between'>
          <hr className='bg-gray-300 w-full h-4 mb-2' />
          <span className='text-red-dark h-14'></span>
        </section>
      </article>
    </>
  );
};
